import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import AddContentBody from '../Body';
import { quizGenerationButtonPropTypes } from '../Body/presenter';
export function AddContentModal(_ref) {
  var allowStimulusCreation = _ref.allowStimulusCreation,
    closeModal = _ref.closeModal,
    modalOpen = _ref.modalOpen,
    _ref$parentEntryId = _ref.parentEntryId,
    parentEntryId = _ref$parentEntryId === void 0 ? void 0 : _ref$parentEntryId,
    position = _ref.position,
    quizId = _ref.quizId,
    _ref$stimulusId = _ref.stimulusId,
    stimulusId = _ref$stimulusId === void 0 ? void 0 : _ref$stimulusId,
    _ref$slotProps = _ref.slotProps,
    slotProps = _ref$slotProps === void 0 ? {} : _ref$slotProps;
  var handleGenerateWithAiClick = function handleGenerateWithAiClick() {
    var _slotProps$quizGenera, _slotProps$quizGenera2;
    slotProps === null || slotProps === void 0 || (_slotProps$quizGenera = slotProps.quizGenerationButton) === null || _slotProps$quizGenera === void 0 || (_slotProps$quizGenera2 = _slotProps$quizGenera.onClick) === null || _slotProps$quizGenera2 === void 0 || _slotProps$quizGenera2.call(_slotProps$quizGenera, position);
    closeModal();
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
    open: modalOpen,
    onDismiss: closeModal,
    size: "large",
    label: t('Add Content')
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
    level: "reset",
    as: "h2"
  }, t('Insert Content')), /*#__PURE__*/React.createElement(CloseButton, {
    onClick: closeModal,
    placement: "end",
    offset: "medium",
    screenReaderLabel: t('Close')
  })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(AddContentBody, {
    allowStimulusCreation: allowStimulusCreation,
    onOpenBankTray: closeModal,
    onAddItem: closeModal,
    parentEntryId: parentEntryId,
    position: position,
    quizId: quizId,
    showHeaderText: false,
    stimulusId: stimulusId,
    containerType: "modal",
    slotProps: {
      quizGenerationButton: _objectSpread(_objectSpread({}, (slotProps === null || slotProps === void 0 ? void 0 : slotProps.quizGenerationButton) || {}), {}, {
        onClick: handleGenerateWithAiClick
      })
    }
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: closeModal
  }, t('Cancel')))));
}
AddContentModal.propTypes = {
  allowStimulusCreation: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  parentEntryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  quizId: PropTypes.string.isRequired,
  stimulusId: PropTypes.string,
  slotProps: PropTypes.shape({
    quizGenerationButton: quizGenerationButtonPropTypes
  })
};
AddContentModal.defaultProps = {
  parentEntryId: void 0,
  stimulusId: void 0
};